import React, {FunctionComponent} from 'react';

import withStyles from '@material-ui/core/styles/withStyles';

import {Styles, styles} from './Left.style';

interface Props extends Styles {}

const HeaderLeft: FunctionComponent<Props> = (props) => {
  const {classes, children} = props;

  return <div className={classes.root}>{children}</div>;
};

export default withStyles(styles)(HeaderLeft);
